/**
 * @generated SignedSource<<3298519dfd4746ee6ce234a9fa29f953>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupPickerGroupHeader_issueTableGrouping$data = {
  readonly group: {
    readonly name: string;
  };
  readonly " $fragmentType": "groupPickerGroupHeader_issueTableGrouping";
};
export type groupPickerGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: groupPickerGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupPickerGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupPickerGroupHeader_issueTableGrouping",
  "selections": [
    {
      "concreteType": "JiraGroup",
      "kind": "LinkedField",
      "name": "group",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlGroupFieldValue"
};

(node as any).hash = "1586f026d7391c5354a0bb5a5a52ee17";

export default node;
